import { IconArrowLeft } from '../icons/generated/ArrowLeft.js';
import { IconArrowRight } from '../icons/generated/ArrowRight.js';
import { jsx } from 'react/jsx-runtime';

const Arrow = _ref => {
  let {
    arrowDirection = 'forward',
    isRtl = false,
    ...rest
  } = _ref;
  return isRtl && arrowDirection === 'forward' || !isRtl && arrowDirection === 'backward' ? /*#__PURE__*/jsx(IconArrowLeft, {
    ...rest
  }) : /*#__PURE__*/jsx(IconArrowRight, {
    ...rest
  });
};

export { Arrow };
